export const palette = {
  gray: {
    50: '#F4F8FB',
    100: '#EDF1F7',
    200: '#E2E8F0',
    300: '#CDD6E4',
    400: '#ACB8CC',
    500: '#8895AE',
    600: '#6C7891',
    650: '#535F78',
    700: '#424E67',
    750: '#323D55',
    800: '#253044',
    850: '#192337',
    900: '#0F172A',
    950: '#090E19',
  },
  primary: {
    50: '#FFE9F2',
    100: '#FFD3E4',
    200: '#FFB6D2',
    300: '#FF99C0',
    400: '#FF6EA5', // Normal
    500: '#FF5093', // Strong
    600: '#EA2A73',
    700: '#C9175B',
    800: '#A10B44', // Base
    900: '#7D0633',
  },
  sub: {
    mint: {
      100: '#D6F3EF',
      400: '#1BC4B3',
      700: '#00A19A',
    },
    yellow: {
      100: '#FFF1C1',
      400: '#FFD954',
      700: '#D7A00B',
    },
    blue: {
      100: '#D9E9FF',
      500: '#3380FF',
      800: '#1E4D9B',
    },
    red: {
      100: '#FEE1DF',
      500: '#FB4136',
      700: '#D0261C',
    },
    purple: {
      100: '#F1ECFB',
      500: '#9248F7',
      800: '#6541CA',
    },
    orange: {
      100: '#FBEAD6',
      600: '#FF5500',
      800: '#AB420D',
    },
    green: {
      100: '#D9F2DC',
      500: '#2D8C3C',
      800: '#1A5C25',
    },
    teal: {
      100: '#D4F1EC',
      500: '#41C9B4',
      800: '#1E8A78',
    },
  },
  black: '#000000',
  white: '#FFFFFF',
} as const

export type Palette = typeof palette
export type ColorScale = keyof typeof palette
export type ShadeLevel = keyof typeof palette.gray
